import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '@companion-professional/webutils';
import { headingVariants } from '../Typography';

// DialogTitle is the title section of the DialogHeader
export const DialogTitle = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Title>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn(headingVariants({ level: 'section' }), className)}
    {...props}
  />
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
